import styled from 'styled-components';

export const Wrapper = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;
	padding: 0 1rem 2rem;
`;
